module.exports = __webpack_public_path__ + "media/arrows/drag-arrow-f726f3ce.svg";